import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  employeeScheduleList: {
    requesting: false,
    items: [],
    pagination: {
      current_page: 1,
      per_page: 10,
      total: 0,
    },
    error: null,
    success: false,
    filters: {},
  },

  employeeScheduleDetails: {
    requesting: false,
    error: null,
    success: false,
    data: null,
  },

  scheduleTemplateOptions: {
    requesting: false,
    items: [],
    error: null,
    success: false,
  },
};

export const employeeScheduleSlice = createSlice({
  name: "employeeSchedule",
  initialState,

  reducers: {
    getEmployeeScheduleList: (state, action) => {
      state.employeeScheduleList.requesting = true;
      state.employeeScheduleList.error = null;
      state.employeeScheduleList.items = [];
      state.employeeScheduleList.success = false;
      state.employeeScheduleList.filters = action.payload;
      state.employeeScheduleDetails.data = null;
    },

    getEmployeeScheduleListSuccess: (state, action) => {
      const { data, current_page, per_page, total } = action.payload;

      state.employeeScheduleList.requesting = false;
      state.employeeScheduleList.items = data;
      state.employeeScheduleList.success = true;
      state.employeeScheduleList.pagination.current_page = current_page;
      state.employeeScheduleList.pagination.per_page = per_page;
      state.employeeScheduleList.pagination.total = total;
    },

    getEmployeeScheduleListFail: (state, action) => {
      state.employeeScheduleList.requesting = false;
      state.employeeScheduleList.error = action.payload;
    },

    getEmployeeScheduleDetails: (state) => {
      state.employeeScheduleDetails.requesting = true;
      state.employeeScheduleDetails.error = null;
      state.employeeScheduleDetails.data = null;
      state.employeeScheduleDetails.success = false;
    },

    getEmployeeScheduleDetailsSuccess: (state, action) => {
      state.employeeScheduleDetails.requesting = false;
      state.employeeScheduleDetails.data = action.payload;
      state.employeeScheduleDetails.success = true;
    },

    getEmployeeScheduleDetailsFail: (state, action) => {
      state.employeeScheduleDetails.requesting = false;
      state.employeeScheduleDetails.error = action.payload;
    },

    doEmployeeScheduleCreate: (state) => {
      state.employeeScheduleDetails.requesting = true;
      state.employeeScheduleDetails.error = null;
      state.employeeScheduleDetails.data = null;
      state.employeeScheduleDetails.success = false;
    },

    doEmployeeScheduleUpdate: (state) => {
      state.employeeScheduleDetails.requesting = true;
      state.employeeScheduleDetails.error = null;
      state.employeeScheduleDetails.data = null;
      state.employeeScheduleDetails.success = false;
    },

    doEmployeeScheduleDelete: (state) => {
      state.employeeScheduleDetails.requesting = true;
      state.employeeScheduleDetails.error = null;
      state.employeeScheduleDetails.data = null;
      state.employeeScheduleDetails.success = false;
    },

    doEmployeeScheduleReset: (state) => {
      state.employeeScheduleDetails.data = null;
    },

    getEmployeeScheduleTemplateOptions: (state) => {
      state.scheduleTemplateOptions.requesting = true;
      state.scheduleTemplateOptions.error = null;
      state.scheduleTemplateOptions.items = [];
      state.scheduleTemplateOptions.success = false;
    },

    getEmployeeScheduleTemplateOptionsSuccess: (state, action) => {
      state.scheduleTemplateOptions.requesting = false;
      state.scheduleTemplateOptions.items = action.payload;
      state.scheduleTemplateOptions.success = true;
    },

    getEmployeeScheduleTemplateOptionsFail: (state, action) => {
      state.scheduleTemplateOptions.requesting = false;
      state.scheduleTemplateOptions.error = action.payload;
      state.scheduleTemplateOptions.success = false;
    },
  },
});

export const {
  getEmployeeScheduleList, getEmployeeScheduleListSuccess,
  getEmployeeScheduleListFail,
  getEmployeeScheduleDetails, getEmployeeScheduleDetailsSuccess,
  getEmployeeScheduleDetailsFail,
  doEmployeeScheduleCreate, doEmployeeScheduleUpdate,
  doEmployeeScheduleDelete, doEmployeeScheduleReset,
  getEmployeeScheduleTemplateOptions, getEmployeeScheduleTemplateOptionsSuccess,
  getEmployeeScheduleTemplateOptionsFail,
} = employeeScheduleSlice.actions;

export default employeeScheduleSlice.reducer;